import React, { useRef, useState } from "react";
import * as Icons from "react-feather";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import axios from "axios";
import SKAlerts, { CreateAlert } from "../../shared/common-alerts/SKAlerts";
import { ReactComponent as SortArrow } from '../../shared/img/chevron-up-down.svg'; 
import LeadModel from "./models/LeadModel";
import { getStorageValues } from "../../shared/CommonFunctions";
import { getApiBaseUrl } from "../../utils/apiConfig";
import LeadModal from "./LeadModal";
import LeadFollowupHistory from "./LeadFollowupHistory";

function LeadGrid(props) {
  const [actionType, setActionType] = useState();
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [leadModel, setLeadModel] = useState(new LeadModel());
  const [filterText, setFilterText] = React.useState("");
  const [alert, setAlert] = useState(null);
  const commentRef = useRef(null);

  const [expandedRowId, setExpandedRowId] = useState([]);

  // ✅ Conditional row styles
  const conditionalRowStyles = [
    {
      when: row => row.IsConverted && row.IsConverted.toLowerCase() === "converted",
      style: {
        backgroundColor: "#e7f9ed", // light green
        color: "#0a3622",
      },
    }
  ];

  const handleRowExpandToggled = (expanded, row) => {
    // Toggle: if already expanded, collapse it
    setExpandedRowId((prev) => (prev === row.ClientLeadId ? null : row.ClientLeadId));
  };
  const isRowExpanded = (row) => row.ClientLeadId === expandedRowId;
  function closeModal() {
    setIsOpen(false);
    props.fetchLead();
  }

  const rows = props.LeadData
    ? props.LeadData.filter(
      (item) =>
        (item.ClientName &&
          item.ClientName.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.MobileNumber &&
          item.MobileNumber.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.EmailId &&
          item.EmailId.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.Description &&
          item.Description.toLowerCase().includes(filterText.toLowerCase()))
    )
    : [];

  const openActionType = (row, name) => {
    const updatedRow = {
    ...row,
    ClientCompanyTypeIds: row.ClientCompanyTypeIds
      ? row.ClientCompanyTypeIds.split(',')
          .map(id => parseInt(id.trim()))
          .filter(Boolean)
      : []
    };
    setLeadModel(updatedRow);
    setIsOpen(true);
    setActionType(name);
  };
  async function onSubmit(e, data) {
    const LeadModel = data;
    if (e.target.name === "Edit") {
      let LeadDetails = {
        LeadId: LeadModel.ClientLeadId,
        ClientName: LeadModel.ClientName,
        MobileNumber: LeadModel.MobileNumber,
        EmailId: LeadModel.EmailId,
        Description: LeadModel.Description,
        ClientCompanyTypeIds: JSON.stringify(LeadModel.ClientCompanyTypeIds || []),
        UserId: getStorageValues('userId')
      };
      if (validation(LeadDetails)) {
        try {
          const response = await axios.post(
            getApiBaseUrl() + "/saveLeadDetails", 
            LeadDetails
          );
          if (response.status === 200) {
            if (response.data.data[0].success === 1) {
              CreateAlert(response.data.data[0].message, "Success", setAlert);
              props.fetchLead();
              closeModal();
            } else {
              CreateAlert(response.data.data[0].message, "Warning", setAlert);
            }
          }
        } catch (error) {
          console.log(error);
        }
      }
    } else if (e.target.name === "Delete") {
      let LeadDetails = {
        LeadId: LeadModel.ClientLeadId
      };
      try {
        const response = await axios.post(
          getApiBaseUrl() + "/deleteLead", LeadDetails
        );
        if (response.status === 200) {
          CreateAlert("Lead deleted successfully!!", "Success", setAlert);
          props.fetchLead();
          closeModal();
        }
      } catch (error) {
        console.log(error);
      }
    } else if (e.target.name === "ConvertLead") {
      let clientDetails = {
        ClientId: null,
        TaxStatusId: 1,
        ModeOfHoldingId: null,
        ClientRatingsId: null,
        ReferedBy: null,
        TitleId: 1,
        ClientName: LeadModel.ClientName ? LeadModel.ClientName : null, 
        FamilyHeadId: null,
        GenderId: 1,
        EmailId: LeadModel.EmailId ? LeadModel.EmailId : null,
        MobileNumber: LeadModel.MobileNumber ? LeadModel.MobileNumber : null,
        DateOfBirth: Date.now(),
        DateOfAnniversary: null,
        PlaceOfBirth: null,
        CountryOfBirth: null,
        Occupation: null,
        PANNo: "xxxxx0000x",
        Nominee: null,
        Address: '<Addresses></Addresses>',
        ClientInvestment: null,
        DPID: null,
        NPSAccountNumber: null,
        AnnualIncome: null,
        GrossAnnualIncome: null,
        NetWorth: null, 
        BankName: null, 
        BranchName: null, 
        AccountNumber: null, 
        IFSCCode: null, 
        LeadId: LeadModel.ClientLeadId,
        UserId: getStorageValues('userId')
      };
      try {
        const response = await axios.post(
          getApiBaseUrl() + "/saveClientDetails",
          clientDetails
        );
        if (response.status === 200) {
          if(response.data.data[0].success === 1){
            CreateAlert("Client Lead converted successfully!!", "Success", setAlert);
            props.fetchLead();
            closeModal();
          } else {
            CreateAlert(response.data.data[0].message, "Error", setAlert);
          }
        } 
      } catch (error) {
        console.log(error);
      }
    }
  };

  function validation(leadDetails) {
    let isValid = true;
    
        if (!leadDetails) {
          CreateAlert("Some problem fetching user details entered by the user!!", "Error", setAlert);
          return false;
        }
    
        if (!leadDetails.ClientName) {
          CreateAlert("Please enter client name!!", "Warning", setAlert);
          return false;
        }
    
        if (!leadDetails.MobileNumber) {
          CreateAlert("Please enter Mobile Number!!", "Warning", setAlert);
          return false;
        }
    
        if (!leadDetails.EmailId) {
          CreateAlert("Please enter email id!!", "Warning", setAlert);
          return false;
        }
    
        return isValid;
  }

  const columns = [
    {
      name:<div className="titlename"><span>Client Name</span></div> ,
      selector: row => row.ClientName,
      cell: (row) => (
        <span title={row.ClientName}>{row.ClientName}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
    {
      name:<div className="titlename"><span>Mobile Number</span></div> ,
      selector: row => row.MobileNumber,
      cell: (row) => (
        <span title={row.MobileNumber}>{row.MobileNumber}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
    {
      name: <div className="titlename"><span>Email</span></div>,
      selector: row => row.EmailId,
      cell: (row) => (
        <span title={row.EmailId}>{row.EmailId}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
    {
      name: <div className="titlename"><span>Product Investment</span></div>,
      selector: row => row.ClientCompanyTypeNames,
      cell: (row) => (
        <span title={row.ClientCompanyTypeNames}>{row.ClientCompanyTypeNames}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
    ];
    if(props.UserPermissions.ViewModule === 1 || props.UserPermissions.EditModule === 1 || props.UserPermissions.DeleteModule === 1 ){
   columns.push({
    
      name: <div className="titlename">Actions</div>,
      cell: (row) => (
        <div className="edit-delete-action" >
          {
           props.UserPermissions.ViewModule === 1 ?
          <Link
            title="View Lead"
            className="me-2 p-2"
            to=""
            onClick={() => {
              openActionType(row, "View");
            }}
          >
            <Icons.Eye data-feather="eye" className="action-eye" />
          </Link>
           : null
         }
         {
           props.UserPermissions.EditModule === 1 ?
          <Link
            title="Edit Lead"
            className={`me-2 p-2 ${row.IsConverted === 'Converted' ? 'disabled-link' : ''}`}
            to=""
            onClick={() => {
              openActionType(row, "Edit");
            }}
          >
            <Icons.Edit data-feather="edit" className="feather-edit" />
          </Link>
          : null
         }
          {
           props.UserPermissions.DeleteModule === 1 ?
          <Link
            title="Delete Lead"
            className={`me-2 p-2 ${row.IsConverted === 'Converted' ? 'disabled-link' : ''}`}
            to=""
            onClick={() => {
              openActionType(row, "Delete");
            }}
          >
            <Icons.Trash2 data-feather="trash-2" className="feather-trash-2" />
          </Link> 
          : null
         }   

          {
            getStorageValues('IsAdmin') === 'true' ?
              <Link
                title="ConvertLead to Client12"
                className={`cme-2 p-2 ${row.IsConverted === 'Converted' ? 'disabled-link' : ''}`}
                to=""
                onClick={() => {
                  openActionType(row, "ConvertLead");
                }}
                
              >
                <Icons.ChevronsRight  data-feather="trash-2" className="feather-edit" />
              </Link>
              : null
            
          }
          
         
          
        </div>
      ),
      center: "true",
      width: "200px"
    },
  
 )
}
  return (
    <>
      <SKAlerts alert={alert} />
      <div className="card table-list-card">
        <div className="card-body">
          <div className="table-top">
            <div className="search-set">
              <div className="search-input">
                <button type="button" className="btn btn-searchset">
                  <Icons.Search className="feather-search" />
                </button>
                <input
                  id="search"
                  type="text"
                  className="form-control form-control-sm custom-search-input"
                  placeholder="Search"
                  aria-label="Search Input"
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                />
              </div>
            </div>
          </div>
          <DataTable
            className="table-responsive product-list"
            columns={columns}
            data={rows}
            pagination
            defaultSortField="ClientName"
            sortIcon={<SortArrow />}
            persistTableHead={true}
            conditionalRowStyles={conditionalRowStyles}
            expandableRows
            onRowExpandToggled={handleRowExpandToggled}
            expandableRowExpanded={isRowExpanded}
            expandableRowsComponentProps={{ ref: commentRef }}
            expandableRowsComponent={LeadFollowupHistory}
            expandableRowDisabled={(row) =>
                row.IsConverted &&
                row.IsConverted.trim().toLowerCase() === "converted"
            }
          />
        </div>
      </div>
      <LeadModal
        show={modalIsOpen}
        UserAction={actionType}
        onClose={closeModal}
        selectedRow={leadModel}
        onSubmit={onSubmit}
      />
    </>
  );
}

export default LeadGrid;
